import React, { Component } from 'react';
import Config from './Configs/criteria.json';
import './CriteriaListWidget.css'
import Switch from 'react-switch';

export default class CriteriaListWidget extends Component {

    constructor(props) {
        super(props);
    }
    handleSaveScreener = () => {
        this.props.handlePopupChange("myscreener");
    }
    handleChange = (checked) => {
        if (this.props.firstLogin) {
            return;
        }
        let presetselected=false;
        if(this.props.savebtnStyleName==="screenersavedbtn"){presetselected=true}
        this.props.handleChange(checked,presetselected,presetselected);
    }
    render() {
        return (
            <div className="CriteriaListWidget" hidden={this.props.uiHidden}>
                <div style={{ float: 'right', display: 'flex', flexDirection: 'row' }}>
                    <div className={this.props.savebtnStyleName} onClick={this.handleSaveScreener}>{this.props.savebtnName}</div>

                    <div className="toggleresult">
                        <label htmlFor="icon-switch">
                            <span>検索結果表示</span>
                            <Switch
                                checked={this.props.showSearchResult}
                                onChange={this.handleChange}
                                height={18}
                                width={44}
                                onColor="#1F3C9C"
                                uncheckedIcon={
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            fontSize: 10,
                                            color: "white",
                                            paddingRight: 2
                                        }}
                                    >
                                        OFF
                        </div>
                                }
                                checkedIcon={
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "100%",
                                            fontSize: 10,
                                            color: "white",
                                            paddingLeft: 3
                                        }}
                                    >
                                        ON
                        </div>
                                }
                                className="react-switch"
                                id="icon-switch"
                            />
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}